import React from 'react'
import { connect } from 'react-redux'
import config from 'config'
import classNames from 'classnames'
import style from './style.module.scss'

const mapStateToProps = ({ settings }) => ({ settings })

@connect(mapStateToProps)
class Footer extends React.Component {
  render() {
    const {
      settings: { isContentNoMaxWidth },
    } = this.props
    return (
      <div
        className={classNames(style.footer, {
          [style.footerFullWidth]: isContentNoMaxWidth,
        })}
      >
        <div className={style.inner}>
          <div className="row">
            <div className="col-md-8">
              <p>
                <strong>{config.app_name}</strong>
              </p>
              <p>{config.app_description}</p>
              <p>
                &copy; {new Date().getFullYear()} {config.footer.license}
              </p>
            </div>
            <div className="col-md-4">
              <div className={style.logo}>
                <img src={config.app_logo.path} alt={config.app_logo.alt} />
                <div className={style.logoName}>{config.footer.logoName}</div>
                <div className={style.logoDescr}>{config.footer.logoDescr}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer
